import Cookies from 'js-cookie'
import defaultSettings from '@/assets/js/mapOption'

const state = {
  defaultStyle: defaultSettings.map.defaultStyle,
  mapStyle: {
    weight: Cookies.get('mapStyle_weight') ? Cookies.get('mapStyle_weight') : defaultSettings.map.style.weight,
    color: Cookies.get('mapStyle_color') ? Cookies.get('mapStyle_color') : defaultSettings.map.style.color,
    opacity: defaultSettings.map.style.opacity,
    fillOpacity: Cookies.get('mapStyle_fillOpacity') ? Cookies.get('mapStyle_fillOpacity') : defaultSettings.map.style.fillOpacity,
    fillColor: defaultSettings.map.style.fillColor
  },
  color: defaultSettings.map.color.defaultRegionalColors,
  heatColor: Cookies.get('heatMapColor') ? Cookies.get('heatMapColor') : 'default',
  mapPopupViewType: Cookies.get('mapPopupViewType') ? Cookies.get('mapPopupViewType') : defaultSettings.map.options.showPopupDataViewType.all
}
const getters = {

  getMapDefaultStyle () {
    return state.defaultStyle
  },

  getMapStyle () {
    return state.mapStylen
  },

  getRegionalColor () {
    return state.color
  },

  getHeatMapColor () {
    return state.heatColor
  },

  getFillOpacity () {
    return state.mapStyle.fillOpacity
  },

  getMapPopupViewType () {
    return state.mapPopupViewType
  }
}
const mutations = {
  mapStyle: (state, mapStyle) => {
    state.mapStyle.color = mapStyle.color
    state.mapStyle.weight = mapStyle.weight

    Cookies.set('mapStyle_color', state.mapStyle.color)
    Cookies.set('mapStyle_weight', state.mapStyle.weight)
  },

  setLayerFillOpacity: (state, fillOpacity) => {
    state.mapStyle.fillOpacity = fillOpacity

    Cookies.set('mapStyle_fillOpacity', state.mapStyle.fillOpacity)
  },

  setMapPopupViewType: (state, viewType) => {
    state.mapPopupViewType = viewType

    Cookies.set('mapPopupViewType', viewType)
  },

  setHeatMapColor: (state, heatColor) => {
    state.heatColor = heatColor

    Cookies.set('heatMapColor', heatColor)
  }
}

const actions = {
  saveMapStyle ({ commit, state }) {
    commit('mapStyle', state.mapStyle)
  },

  clearMapStyle ({ commit }) {
    commit('mapStyle', defaultSettings.map.style)
  },

  setLayerFillOpacity ({ state, commit }, { fillOpacity }) {
    commit('setLayerFillOpacity', fillOpacity)
  },

  setMapPopupViewType ({ state, commit }, { viewType }) {
    commit('setMapPopupViewType', viewType)
  },

  setHeatMapColor ({ state, commit }, { heatColor }) {
    commit('setHeatMapColor', heatColor)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
